<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">
        {{title}}
    </div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <!-- Search -->
    <div class="row">
        <div class="col">
            <form [formGroup]="searchFilterForm" class="d-flex mb-3 px-1">
                <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
                    aria-label="Search">
                <button type="submit" class="bordersearch" (click)="clickSearch()"><i
                        class="far fa-search grey"></i></button>
            </form>
        </div>
    </div>
    <div class="row  modal-body-overflow"
    infinite-scroll
    [infiniteScrollUpDistance]="9"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="busyGettingData"
    (scrolled)="onScrollDown()"
    [scrollWindow]="false">
        <div class="col" *ngIf="loading == true">
            <img [src]="loadingImage" alt="Loading..." class="image">
        </div>

        <div class="col" *ngIf="imagesList.length == 0 && loading== false">
            <p class="text-center">
                Nessuna immagine presente
            </p>
        </div>
        <div id="{{image.id}}"
        class="img-container m-1 search-results"
        *ngFor="let image of imagesList; index as i"
        (click)="selectImage(image.id)">
            <img *ngIf="image.published" appImageLoader loader="/assets/images/spinner/iphone-spinner-1.gif"
                onErrorSrc="/assets/images/no-image-icon.png" [src]="image.url" alt="{{image.name}}" class="image">
            <img *ngIf="!image.published" [src]="image.url" alt="{{image.name}}" class="image">
            <div class="content">
                <span class="text">{{image.name}}</span>
            </div>
            <div class="overlay-full" [hidden]="!image.selected">
                <i class="fas fa-check"></i>
            </div>
        </div>
    </div>

    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="submit" class="btn btn-fw text me-3" (click)="clickConfirm()">Conferma</button>
            <button type="button" class="btn btn-outline-fw text" (click)="clickCancel()">Annulla</button>
        </div>
    </div>
</div>